<template>
  <v-form>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            v-model="selectedBrand"
            :items="brands"
            item-text="brandName"
            item-value="brandId"
            return-object
            :label="$t('brand')"
            :placeholder="$t('sales.select-brand')"
            v-on:change="changeBland(`${selectedBrand.brandId}`)"
          ></v-select>
          <v-select
            v-model="selectedStore"
            :items="selectedBrand.stores"
            item-text="storeName"
            item-value="storeCode"
            return-object
            :label="$t('store')"
            :placeholder="$t('sales.select-store')"
            required
            no-data-text="ブランドに紐づく店舗が１つもありません"
          ></v-select>
        </v-flex>
      </v-layout>
      <div style="height: 30px;"></div>
      <v-btn class="title" block color="#4C728A" dark @click="order()">
        {{ $t('sales.order-btn') }}
      </v-btn>
      <div style="height: 10px;"></div>
      <v-btn class="title" block color="#4C728A" dark @click="report()">
        {{ $t('sales.sales-report-btn') }}
      </v-btn>
      <div style="height: 10px;"></div>

      <!-- RFID -->
      <!-- <v-btn class="title" block color="#3261e3" dark @click="forwardStoreStockRegist()">
        {{ $t('sales.store-stock-management-btn') }}
      </v-btn> -->
      
      <!-- <v-btn class="title" block color="#4C728A" disabled @click="returnItems()">返品処理</v-btn>
      <div style="height: 10px;"></div> -->
      
      <!-- 店舗在庫棚卸 -->
      <v-btn
        class="title"
        block
        color="error"
        v-bind:disabled="!dispStocktakingBtn"
        dark
        @click="stocktaking()"
      >{{ $t('sales.stocktaking-btn') }}</v-btn>

      <div style="height: 50px;"></div>

      <v-data-table :headers="headers" :items="businessContacts" class="elevation-1" hide-actions>
        <template v-slot:headers="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text" style="padding: 15px;" >{{ header.text }}</th>
          </tr>
        </template>

        <template v-slot:items="props">
          <td class="text-xs-center" style="padding: 0px;">
            <v-icon v-if="props.item.isImportant === '1'" color="red darken-3">report</v-icon>
            <v-icon v-else color="blue-grey lighten-4">report</v-icon>
          </td>
          <td class="text-xs-center" style="padding: 0px;">{{ props.item.createdAt }}</td>
          <td class="text-xs-left" style="white-space:pre-wrap; padding: 15px;" >{{ props.item.notice }}</td>
        </template>
      </v-data-table>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('user menu')

    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    let thisObj = this

    ServerApiCallService.menu()
      .then(response => {
        thisObj.brands = response.data.brands
        thisObj.businessContacts = response.data.businessContacts
        thisObj.businessContacts.forEach(function(row) {
          let formattedCreatedAt =
            // row.createdAt.substring(0, 4) +
            // '/' +
            row.createdAt.substring(4, 6) + '/' + row.createdAt.substring(6, 8)
          row.createdAt = formattedCreatedAt
        })

        console.log(`thisObj.brand+ `, thisObj.brands);
        console.log(`thisObj.businessContacts+ `, thisObj.businessContacts);
        

        // 店舗在庫棚卸ボタンの表示
        var nowMonth = moment().format('YYYYMM')

        var dispStocktakingBtnTermStart = 3
        var dispStocktakingBtnTermEnd = 2

        thisObj.stocktakingDates = response.data.stocktakingDates

        // console.log(moment().format('DD') === '01')

        // 今日が月初なのかを判断
        var isStartOfMonth = moment().format('DD') === '01'

        thisObj.stocktakingDates.forEach(function(row) {
          if (nowMonth === row.stocktakingMonth) {
            // console.log('stocktakingDate: ' + row.stocktakingDate)
            // console.log('now time: ' + moment().format('YYYY/MM/DD HH:mm'))

            thisObj.stocktakingDate = row.stocktakingDate            

            var dispStocktakingBtnTermStartDate = moment(thisObj.stocktakingDate, 'YYYYMMDD').subtract(dispStocktakingBtnTermStart, 'days')
            var dispStocktakingBtnTermEndDate = moment(thisObj.stocktakingDate, 'YYYYMMDD').add(dispStocktakingBtnTermEnd, 'days')

            // 棚卸日の3日前から翌日までボタンを表示する
            if ( dispStocktakingBtnTermStartDate <= moment() && moment() <= dispStocktakingBtnTermEndDate ) {
              thisObj.dispStocktakingBtn = true
            }
          }

          // 月初の場合の処理
          if (isStartOfMonth) {
            if (
              moment()
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYYMMDD') === row.stocktakingDate
            ) {
              thisObj.stocktakingDate = row.stocktakingDate
              thisObj.dispStocktakingBtn = true
            }
          }
        })
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    selectedBrand: {
      get() {
        return this.$store.state.salesSession.menuSelectedBrand
      },
      set(value) {
        this.$store.commit('SET_MENU_SELECTED_BRAND', value)
      }
    },
    selectedStore: {
      get() {
        return this.$store.state.salesSession.menuSelectedStore
      },
      set(value) {
        this.$store.commit('SET_MENU_SELECTED_STORE', value)
      }
    }
  },
  methods: {
    changeBland(brandId) {
      this.brands.forEach(() => {
        if (this.brandId === brandId) {
          this.selectedBrand = this
        }
        console.log(this.selectedBrand.brandId)
        console.log(this.$store.state.salesSession.menuSelectedBrand);
        
      })
    },
    order() {
      console.log('order')

      if (this.selectedBrand.brandId === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-brand')
        )
        return
      }
      if (this.selectedStore.storeCode === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-store')
        )
        return
      }
      
      // 次画面に遷移する前に、stateを初期化
      this.clearState()

      this.$router.push({
        name: 'sales/new-order-send'
      })
    },
    report() {
      console.log('report')

      if (this.selectedBrand.brandId === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-brand')
        )
        return
      }
      if (this.selectedStore.storeCode === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-store')
        )
        return
      }

      // 次画面に遷移する前に、stateを初期化
      this.clearState()

      this.$router.push({
        name: 'sales/SalesReport'
      })
    },
    forwardStoreStockRegist() {
      console.log('forwardStoreStockRegist')

      if (this.selectedBrand.brandId === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-brand')
        )
        return
      }
      if (this.selectedStore.storeCode === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-store')
        )
        return
      }

      console.log("this.selectedStore: ", this.selectedStore);

      // 次画面に遷移する前に、stateを初期化
      this.clearState()

      this.$router.push({
        name: 'sales/StoreStockManagement',
        params: {
          storeCode: this.selectedStore.storeCode,
          storeName: this.selectedStore.storeName
        }
      })
    },
    returnItems() {
      console.log('return')

      if (this.selectedBrand.brandId === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-brand')
        )
        return
      }
      if (this.selectedStore.storeCode === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-store')
        )
        return
      }

      // 次画面に遷移する前に、stateを初期化
      this.clearState()

      this.$router.push({
        name: 'sales/ReturnItems'
      })
    },
    stocktaking() {
      console.log('stocktaking')

      // 管理者側で設定いた棚卸日+翌日まで利用できる
      // 棚卸日前の日付の場合、画面遷移しない
      // TODO 2020.3のみ2日前がら利用可能とする
      // TODO 2020.4から修正必要
      if (moment() < moment(this.stocktakingDate, 'YYYYMMDD')) {
        return
      }

      if (this.selectedBrand.brandId === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-brand')
        )
        return
      }
      if (this.selectedStore.storeCode === '#') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.error-non-selected-store')
        )
        return
      }

      // 次画面に遷移する前に、stateを初期化
      this.clearState()

      this.$router.push({
        name: 'sales/Stocktaking'
      })
    },
    clearState() {
      // 次画面に遷移する前に、stateを初期化
      this.$store.commit('SET_ORDER_SELECTED_ITEMS', [])

      this.$store.commit('SET_MENU_SELECTED_BRAND', this.selectedBrand)
      this.$store.commit('SET_MENU_SELECTED_STORE', this.selectedStore)

      this.$store.commit('SET_ORDER_SELECTED_SHIPPING_DATE', '')
      this.$store.commit('SET_ORDER_REMARKS', '')
      this.$store.commit('SET_SALES_REPORT_DATE', '')
      this.$store.commit('SET_SALES_REPORT_ITEMS', [])
      this.$store.commit('SET_SELECTED_USERS', [])
      this.$store.commit('SET_REPORT_COMMENTS', [])
    }
  },
  data() {
    return {
      stocktakingDate: '',
      dispStocktakingBtn: false,
      stocktakingDates: [],
      brands: [],
      businessContacts: [],
      headers: [
        {
          text: this.$t('important'),
          value: 'isImportant',
          sortable: false,
          align: 'center',
          width: '5%'
        },
        {
          text: this.$t('sales.table-header-registerDate'),
          value: 'createdAt',
          sortable: false,
          width: '20%'
        },
        {
          text: this.$t('sales.table-header-contact'),
          value: 'notice',
          sortable: false,
          width: '75%'
        }
      ]
    }
  }
}
</script>
